module.exports = __webpack_public_path__ + "static/home-193509c013d17e404a7fbe6aa735f9bf.jpg";